// Clash Royale seviye/upgrade hesap tabloları — kullanıcı sağladı (Temmuz 2025)
// Yeni Kart Sistemi (Common: 1-16, Rare: 3-16, Epic: 6-16, Legendary: 9-16, Champion: 11-16)

// row L = display level'e ULAŞMAK için gereken kart sayısı (L-1 -> L)
export const CARD_REQ = {
  common: {
    1: 1, 2: 2, 3: 4, 4: 10, 5: 20, 6: 50, 7: 100, 8: 200, 9: 400, 10: 800,
    11: 1000, 12: 1500, 13: 2500, 14: 3500, 15: 5500, 16: 7500,
  },
  rare: {
    3: 1, 4: 2, 5: 4, 6: 10, 7: 20, 8: 50, 9: 100, 10: 200, 11: 300, 12: 400,
    13: 550, 14: 750, 15: 1000, 16: 1400,
  },
  epic: {
    6: 1, 7: 2, 8: 4, 9: 10, 10: 20, 11: 30, 12: 50, 13: 70, 14: 100, 15: 130, 16: 180,
  },
  legendary: {
    9: 1, 10: 2, 11: 4, 12: 6, 13: 9, 14: 12, 15: 14, 16: 20,
  },
  champion: {
    11: 1, 12: 2, 13: 5, 14: 8, 15: 11, 16: 15,
  },
};

// row L = display level'e ULAŞMAK için gereken altın (L-1 -> L)
export const GOLD_REQ = {
  common: {
    2: 5, 3: 20, 4: 50, 5: 150, 6: 400, 7: 1000, 8: 2000, 9: 4000, 10: 8000,
    11: 15000, 12: 25000, 13: 40000, 14: 60000, 15: 90000, 16: 120000,
  },
  rare: {
    4: 50, 5: 150, 6: 400, 7: 1000, 8: 2000, 9: 4000, 10: 8000,
    11: 15000, 12: 25000, 13: 40000, 14: 60000, 15: 90000, 16: 120000,
  },
  epic: {
    7: 400, 8: 2000, 9: 4000, 10: 8000, 11: 15000, 12: 25000, 13: 40000, 14: 60000, 15: 90000, 16: 120000,
  },
  legendary: {
    10: 5000, 11: 15000, 12: 25000, 13: 40000, 14: 60000, 15: 90000, 16: 120000,
  },
  champion: {
    12: 25000, 13: 40000, 14: 60000, 15: 90000, 16: 120000,
  },
};

// CR API'nin dönerdiği level → görüntülenen (display) level'e çevirmek için offset.
// API'de her nadirlik kendi 1'inden başlar; oyunda ise ortak (birleşik) seviye görülür.
export const RARITY_OFFSET = {
  common: 0,
  rare: 2,
  epic: 5,
  legendary: 8,
  champion: 10,
};

// Her nadirlik için display açılış seviyesi
export const RARITY_UNLOCK = {
  common: 1,
  rare: 3,
  epic: 6,
  legendary: 9,
  champion: 11,
};

export const MAX_DISPLAY_LEVEL = 16;

// Fazlalık kartların Kristal'e dönüşüm oranları (1 kart = X kristal)
export const CRYSTAL_RATE = {
  common: 1,
  rare: 6,
  epic: 60,
  legendary: 600,
  champion: 1200,
};

export const RARITY_TR = {
  common: "Sıradan",
  rare: "Nadir",
  epic: "Destansı",
  legendary: "Efsanevi",
  champion: "Şampiyon",
};

export const RARITY_COLOR = {
  common: "text-slate-200",
  rare: "text-orange-300",
  epic: "text-fuchsia-300",
  legendary: "text-rose-300",
  champion: "text-amber-300",
};

export const RARITY_RANK = { champion: 0, legendary: 1, epic: 2, rare: 3, common: 4 };

/** API level → display level */
export function toDisplayLevel(apiLevel, rarity) {
  if (apiLevel == null) return null;
  return apiLevel + (RARITY_OFFSET[rarity] || 0);
}

/** display level → API level */
export function toApiLevel(displayLevel, rarity) {
  if (displayLevel == null) return null;
  return displayLevel - (RARITY_OFFSET[rarity] || 0);
}

/**
 * Bir sonraki seviyeye çıkmak için gereken kart sayısı.
 * Örn: displayLevel=15, rarity=common -> 7500 (16'ya ulaşmak için).
 * MAX seviyedeyse null döner.
 */
export function cardsForNextLevel(displayLevel, rarity) {
  if (displayLevel == null || displayLevel >= MAX_DISPLAY_LEVEL) return null;
  const table = CARD_REQ[rarity] || {};
  return table[displayLevel + 1] || null;
}

/** Bir sonraki seviyeye çıkmak için altın */
export function goldForNextLevel(displayLevel, rarity) {
  if (displayLevel == null || displayLevel >= MAX_DISPLAY_LEVEL) return null;
  const table = GOLD_REQ[rarity] || {};
  return table[displayLevel + 1] || null;
}

/**
 * Mevcut display level'den 16'ya kadar toplam kart + altın gereksinimi.
 * Eğer kart hiç açılmamışsa (locked), displayLevel=null verilir → unlock (row 1) dahil.
 */
export function totalToMax(displayLevel, rarity) {
  const cardTable = CARD_REQ[rarity] || {};
  const goldTable = GOLD_REQ[rarity] || {};
  let cards = 0;
  let gold = 0;
  // Kilitli kart: unlock seviyesine ULAŞMAK için 1 kart lazım (row = unlock level'de)
  const startFromLevel = displayLevel != null ? displayLevel + 1 : RARITY_UNLOCK[rarity];
  for (let L = startFromLevel; L <= MAX_DISPLAY_LEVEL; L++) {
    if (cardTable[L]) cards += cardTable[L];
    if (goldTable[L]) gold += goldTable[L];
  }
  return { cards, gold };
}

/**
 * Bir karta ait ilerleme çubuğu verisini hesaplar.
 * Dönen: {display_level, is_max, needed_next, next_level, gold_needed}
 */
export function progressBarInfo(card) {
  const rarity = card.rarity;
  const displayLevel = toDisplayLevel(card.level, rarity);
  const isMax = displayLevel != null && displayLevel >= MAX_DISPLAY_LEVEL;
  if (isMax) {
    return {
      displayLevel,
      isMax: true,
      neededNext: null,
      nextLevel: null,
      goldNeeded: null,
    };
  }
  return {
    displayLevel,
    isMax: false,
    neededNext: cardsForNextLevel(displayLevel, rarity),
    nextLevel: displayLevel != null ? displayLevel + 1 : RARITY_UNLOCK[rarity],
    goldNeeded: goldForNextLevel(displayLevel, rarity),
  };
}

/**
 * Bütün hesap için "Hesabı Maxla" özet hesabı.
 *
 * @param {Array} ownedCards  - Backend'ten gelen owned cards
 * @param {Array} lockedCards - Backend'ten gelen locked cards
 * @returns özet: {byRarity, totalGold, totalCrystals, totalDeficitCards, totalSurplusCards}
 */
export function computeMaxSummary(ownedCards, lockedCards) {
  const byRarity = {};
  const rarities = ["common", "rare", "epic", "legendary", "champion"];
  for (const r of rarities) {
    byRarity[r] = {
      rarity: r,
      wildCardsNeeded: 0,   // eksik kartlar (joker olarak)
      surplusCards: 0,      // 16'ya ulaştıktan sonra artan kartlar
      crystals: 0,          // fazlalıklardan gelen kristal
      goldNeeded: 0,
      lockedCount: 0,
      unmaxedCount: 0,
      maxedCount: 0,
    };
  }

  for (const c of ownedCards || []) {
    const r = c.rarity;
    if (!byRarity[r]) continue;
    const displayLevel = toDisplayLevel(c.level, r);
    const { cards: needCards, gold: needGold } = totalToMax(displayLevel, r);
    const count = c.count || 0;
    if (needCards === 0) {
      // Zaten max
      byRarity[r].maxedCount += 1;
      byRarity[r].surplusCards += count;
    } else {
      byRarity[r].unmaxedCount += 1;
      byRarity[r].goldNeeded += needGold;
      if (count >= needCards) {
        // Elimizde yetenli var → max olduktan sonra kalanları kristale
        byRarity[r].surplusCards += (count - needCards);
      } else {
        byRarity[r].wildCardsNeeded += (needCards - count);
      }
    }
  }

  for (const c of lockedCards || []) {
    const r = c.rarity;
    if (!byRarity[r]) continue;
    const { cards: needCards, gold: needGold } = totalToMax(null, r);
    byRarity[r].wildCardsNeeded += needCards;
    byRarity[r].goldNeeded += needGold;
    byRarity[r].lockedCount += 1;
  }

  // Kristal hesabı
  let totalCrystals = 0;
  let totalGold = 0;
  let totalDeficit = 0;
  let totalSurplus = 0;
  for (const r of rarities) {
    const b = byRarity[r];
    b.crystals = b.surplusCards * (CRYSTAL_RATE[r] || 0);
    totalCrystals += b.crystals;
    totalGold += b.goldNeeded;
    totalDeficit += b.wildCardsNeeded;
    totalSurplus += b.surplusCards;
  }

  return {
    byRarity,
    totalGold,
    totalCrystals,
    totalDeficitCards: totalDeficit,
    totalSurplusCards: totalSurplus,
  };
}

/** Kahramanları (champion) max yapmak için gereken toplam kart sayısı özeti */
export function computeHeroSummary(champions) {
  let unlockedCount = 0;
  let lockedCount = 0;
  let piecesOwned = 0;
  let piecesNeededForNext = 0;
  let piecesToMaxAll = 0;
  for (const ch of champions || []) {
    if (ch.unlocked) {
      unlockedCount += 1;
      piecesOwned += ch.count || 0;
      const displayLevel = toDisplayLevel(ch.level, "champion");
      const { cards } = totalToMax(displayLevel, "champion");
      piecesToMaxAll += Math.max(0, cards - (ch.count || 0));
      const need = cardsForNextLevel(displayLevel, "champion");
      if (need) piecesNeededForNext += Math.max(0, need - (ch.count || 0));
    } else {
      lockedCount += 1;
      const { cards } = totalToMax(null, "champion");
      piecesToMaxAll += cards;
    }
  }
  return {
    unlockedCount,
    lockedCount,
    piecesOwned,
    piecesNeededForNext,
    piecesToMaxAll,
  };
}

/**
 * Koleksiyon Seviyesi Hesaplama Motoru.
 *
 * Kurallar (kullanıcının tanımı):
 *   • Her yeni kart seviyesi = +1 koleksiyon seviyesi
 *   • Her yeni evrim (evrim seviyesi) = +5 koleksiyon seviyesi
 *   • Her yeni kahraman (Hero) = +5 koleksiyon seviyesi
 *
 * @param {Object} args
 * @param {number} args.currentLevel        Şu anki koleksiyon seviyesi (id.collection_level)
 * @param {number} args.targetLevel         Ulaşmak istediğimiz koleksiyon seviyesi
 * @param {number} args.newEvos             Manuel: kaç yeni evrim açmayı planlıyoruz
 * @param {number} args.newHeroes           Manuel: kaç yeni kahraman açmayı planlıyoruz
 * @param {Array}  args.cards               Sahip olunan kartlar (level, count, rarity)
 * @param {boolean} args.useJoker           Joker (wild card) kullanabilir miyiz
 * @returns {Object} {feasible, deltaTarget, deltaFromEvos, deltaFromHeroes,
 *                    upgradesNeeded, upgrades:[{name,rarity,fromLevel,toLevel,gold,cardsUsed}],
 *                    totalGold, wildCardsByRarity, remainingNeeded}
 */
export function computeCollectionLevelPlan(args) {
  const {
    currentLevel = 0,
    targetLevel = 0,
    newEvos = 0,
    newHeroes = 0,
    cards = [],
    useJoker = false,
    jokerCaps = null, // { common, rare, epic, legendary, champion } — null = sınırsız
  } = args;

  // Manuel modda başlangıçta wild kredisi olarak sayılan miktar
  const capsGiven = !!(jokerCaps && Object.values(jokerCaps).some((v) => v != null && v > 0));

  const delta = Math.max(0, targetLevel - currentLevel);
  const fromEvos = newEvos * 5;
  const fromHeroes = newHeroes * 5;
  const needFromCards = Math.max(0, delta - fromEvos - fromHeroes);

  // Her sahip olunan kart için olası kart seviye yükseltmelerini (upgrade slot'ları) çıkar
  // Her slot: { name, rarity, fromLevel, toLevel, gold, cardsNeeded, cumulativeCardsFromStart }
  // No-joker modda: cumulativeCardsFromStart <= card.count olan slot'lar seçilebilir.
  // Joker mode: tüm slot'lar seçilebilir; count'tan eksik olan kısımlar wild card sayılır.
  const slots = [];
  for (const c of cards || []) {
    const r = c.rarity;
    if (!CARD_REQ[r]) continue;
    const displayLevel = toDisplayLevel(c.level, r);
    if (displayLevel == null) continue;
    let cumulative = 0;
    for (let L = displayLevel + 1; L <= MAX_DISPLAY_LEVEL; L++) {
      const cardsNeeded = CARD_REQ[r][L] || 0;
      const goldNeeded = GOLD_REQ[r][L] || 0;
      if (cardsNeeded === 0 && goldNeeded === 0) continue;
      cumulative += cardsNeeded;
      slots.push({
        cardId: c.id,
        name: c.name,
        rarity: r,
        fromLevel: L - 1,
        toLevel: L,
        gold: goldNeeded,
        cardsNeeded,
        cumulativeCardsFromStart: cumulative,
        ownedCount: c.count || 0,
      });
    }
  }

  // Slot'ları uygunluk + ucuzluğa göre sırala
  //  - No-joker: cumulative <= owned; ardından gold ASC
  //  - Joker: hepsi seçilebilir; gold ASC
  let candidates;
  if (useJoker) {
    candidates = slots.slice();
  } else {
    candidates = slots.filter((s) => s.cumulativeCardsFromStart <= s.ownedCount);
  }
  candidates.sort((a, b) => a.gold - b.gold);

  // Aynı karttan sıralı adımlar seçilirse önce alt seviyenin seçilmesi zorunlu; ama sort by gold zaten
  // düşük seviyeleri önce koyar (çünkü gold düşük seviyede daha az). Yine de dependency kontrolü:
  // Bir slot seçmek için o karttaki ondan önceki tüm slot'ların da seçili olması lazım.
  const chosen = [];
  const chosenPerCard = {}; // cardId -> max toLevel chosen
  const wildUsedByRarity = { common: 0, rare: 0, epic: 0, legendary: 0, champion: 0 };
  const deficitPerCard = {}; // cardId -> current highest deficit (jokerCaps için)

  const tryAcceptSlot = (s, cardObj) => {
    if (!useJoker || !capsGiven) return { ok: true, deltaDef: 0 };
    const newDeficit = Math.max(0, s.cumulativeCardsFromStart - (cardObj?.count || 0));
    const prevDeficit = deficitPerCard[s.cardId] || 0;
    const deltaDef = newDeficit - prevDeficit;
    const cap = jokerCaps[s.rarity];
    if (cap != null && (wildUsedByRarity[s.rarity] + deltaDef) > cap) {
      return { ok: false, deltaDef: 0 };
    }
    return { ok: true, deltaDef, newDeficit };
  };
  const commitSlot = (s, deltaDef, newDeficit) => {
    if (useJoker && capsGiven) {
      wildUsedByRarity[s.rarity] += deltaDef;
      if (newDeficit != null) deficitPerCard[s.cardId] = newDeficit;
    }
  };

  let toGain = needFromCards;
  // Öncelikle gold-ASC sırayla dolaş
  for (const s of candidates) {
    if (toGain <= 0) break;
    // Aynı karttan sıralı ilerlemeliyiz
    const key = s.cardId;
    const already = chosenPerCard[key] ?? s.fromLevel + 1; // ilk slotun fromLevel'ı = display+1-1
    // s.fromLevel = last chosen toLevel olmalı ya da yoksa displayLevel
    // Eğer chosenPerCard[key] varsa ve s.fromLevel != chosenPerCard[key], atla — sıradaki değil
    if (chosenPerCard[key] != null && s.fromLevel !== chosenPerCard[key]) {
      continue;
    }
    if (chosenPerCard[key] == null && s.fromLevel !== toDisplayLevel(
      (cards.find((c) => c.id === s.cardId) || {}).level,
      s.rarity,
    )) {
      continue;
    }
    const cardObj = cards.find((c) => c.id === s.cardId);
    const acc = tryAcceptSlot(s, cardObj);
    if (!acc.ok) continue;
    commitSlot(s, acc.deltaDef, acc.newDeficit);
    chosen.push(s);
    chosenPerCard[key] = s.toLevel;
    toGain -= 1;
    void already;
  }

  // İkinci geçiş — hâlâ eksik kaldıysa: dependency zinciri nedeniyle birinci geçiş ucuz slot'u
  // alamamış olabilir. Bu durumda seçilmemiş kartlardan bir düşük seviye ekleyip zincirlemeye izin verelim.
  // Basit yaklaşım: kalan kart yükseltme sayısı > 0 iken, henüz kullanılmamış kartlardan sırayla ilk slot'u ekle.
  if (toGain > 0) {
    // Kartları düşük "gerekli altın" sırasına göre değerlendir
    const cardsSorted = [...(cards || [])].sort((a, b) => {
      const la = toDisplayLevel(a.level, a.rarity);
      const lb = toDisplayLevel(b.level, b.rarity);
      const ga = (GOLD_REQ[a.rarity] || {})[la + 1] || Infinity;
      const gb = (GOLD_REQ[b.rarity] || {})[lb + 1] || Infinity;
      return ga - gb;
    });
    let progress = true;
    while (toGain > 0 && progress) {
      progress = false;
      for (const c of cardsSorted) {
        if (toGain <= 0) break;
        const dl = toDisplayLevel(c.level, c.rarity);
        if (dl == null || dl >= MAX_DISPLAY_LEVEL) continue;
        const nextLevel = (chosenPerCard[c.id] ?? dl) + 1;
        if (nextLevel > MAX_DISPLAY_LEVEL) continue;
        const table = CARD_REQ[c.rarity] || {};
        const goldTable = GOLD_REQ[c.rarity] || {};
        const cardsNeeded = table[nextLevel] || 0;
        const gold = goldTable[nextLevel] || 0;
        // Yeni cumulative
        // cumulative reconstruction — cheaper to compute from scratch
        let cumulative = 0;
        for (let L = dl + 1; L <= nextLevel; L++) {
          cumulative += table[L] || 0;
        }
        if (!useJoker && cumulative > (c.count || 0)) continue;
        // Zaten seçildi mi kontrol et
        if (chosen.some((x) => x.cardId === c.id && x.toLevel === nextLevel)) continue;
        const tentativeSlot = {
          cardId: c.id,
          name: c.name,
          rarity: c.rarity,
          fromLevel: nextLevel - 1,
          toLevel: nextLevel,
          gold,
          cardsNeeded,
          cumulativeCardsFromStart: cumulative,
          ownedCount: c.count || 0,
        };
        const acc = tryAcceptSlot(tentativeSlot, c);
        if (!acc.ok) continue;
        commitSlot(tentativeSlot, acc.deltaDef, acc.newDeficit);
        chosen.push(tentativeSlot);
        chosenPerCard[c.id] = nextLevel;
        toGain -= 1;
        progress = true;
      }
    }
  }

  // Toplamlar
  let totalGold = 0;
  const wildByRarity = { common: 0, rare: 0, epic: 0, legendary: 0, champion: 0 };
  for (const s of chosen) {
    totalGold += s.gold;
    if (useJoker) {
      const deficit = Math.max(
        0,
        s.cumulativeCardsFromStart - (s.ownedCount || 0),
      );
      // Yalnızca ilk kez seçilen slot deficit'e katkı sağlar. Sıralı seçimde her slot bir sonrakinin
      // cumulative'ini artırır — o yüzden en yüksek seçilen slot'un deficit'i toplamı verir.
      // Aşağıda son geçişte tekrar hesaplarız.
      void deficit;
    }
  }
  // Wild cards: her kart için, chosen slotları arasından en yüksek toLevel'ın cumulative - ownedCount
  if (useJoker) {
    const byCard = {};
    for (const s of chosen) {
      const prev = byCard[s.cardId];
      if (!prev || s.toLevel > prev.toLevel) byCard[s.cardId] = s;
    }
    for (const s of Object.values(byCard)) {
      const deficit = Math.max(
        0,
        s.cumulativeCardsFromStart - (s.ownedCount || 0),
      );
      wildByRarity[s.rarity] = (wildByRarity[s.rarity] || 0) + deficit;
    }
  }

  return {
    feasible: toGain === 0,
    deltaTarget: delta,
    deltaFromEvos: fromEvos,
    deltaFromHeroes: fromHeroes,
    deltaFromCards: needFromCards,
    upgradesChosen: chosen.length,
    upgrades: chosen,
    totalGold,
    wildCardsByRarity: wildByRarity,
    remainingNeeded: toGain,
  };
}


/**
 * Aynı karttan ardışık seviye yükseltmelerini tek satırda birleştir.
 * ör: Kart A 11→12, A 12→13 → A 11→13 (toplam altın+cards+deficit birleşir)
 */
export function mergeConsecutiveUpgrades(upgrades) {
  if (!Array.isArray(upgrades) || upgrades.length === 0) return [];
  // Aynı kart için toLevel ASC sırala
  const byCard = new Map();
  for (const u of upgrades) {
    if (!byCard.has(u.cardId)) byCard.set(u.cardId, []);
    byCard.get(u.cardId).push(u);
  }
  const merged = [];
  for (const [, list] of byCard) {
    list.sort((a, b) => a.toLevel - b.toLevel);
    let cur = null;
    for (const u of list) {
      if (!cur) {
        cur = { ...u };
        continue;
      }
      if (u.fromLevel === cur.toLevel) {
        // ardışık — birleştir
        cur.toLevel = u.toLevel;
        cur.gold += u.gold || 0;
        cur.cardsNeeded = (cur.cardsNeeded || 0) + (u.cardsNeeded || 0);
        // cumulativeCardsFromStart: sonuncunun değerini al (en yüksek)
        cur.cumulativeCardsFromStart = u.cumulativeCardsFromStart;
      } else {
        merged.push(cur);
        cur = { ...u };
      }
    }
    if (cur) merged.push(cur);
  }
  // Global sıralama: en pahalı grup üstte olsun (toplam altın DESC)
  merged.sort((a, b) => (b.gold || 0) - (a.gold || 0));
  return merged;
}

/**
 * Hesabın ulaşabileceği MAX (teorik, tamamen maxlanmış) koleksiyon seviyesi.
 *
 * Kullanıcı tanımı (dinamik — sayılar API'den gelir, yeni kart/evrim/kahraman
 * geldikçe otomatik güncellenir):
 *   • Her kart 16 seviye  → kart_sayısı × 16
 *   • Her kule birliği 16 → kule_sayısı × 16
 *   • Her evrim 5         → evrim_sayısı × 5
 *   • Her kahraman 5      → kahraman_sayısı × 5
 *
 * Örn (Temmuz 2025): 122×16 + 4×16 + 41×5 + 16×5.
 */
export function computeMaxPossibleCL(data, extraNewEvos = 0, extraNewHeroes = 0) {
  if (!data) return 0;
  const c = data.counts || {};
  const cardCount =
    c.cards_total ??
    ((data.cards?.length || 0) + (data.locked_cards?.length || 0));
  const towerCount = c.support_cards_total ?? (data.support_cards?.length || 0);
  const evoCount = c.evolutions_total ?? (data.evolutions?.length || 0);
  const heroCount = c.heroes_total ?? (data.heroes?.length || 0);

  return (
    cardCount * 16 +
    towerCount * 16 +
    (evoCount + (extraNewEvos || 0)) * 5 +
    (heroCount + (extraNewHeroes || 0)) * 5
  );
}

